import React from "react";
import { KPIData } from "../types";

interface KPICardProps {
  data: KPIData;
}

export const KPICard: React.FC<KPICardProps> = ({ data }) => {
  return (
    <article className="relative p-5 pb-4 rounded-[18px] bg-gradient-to-br from-[#22284d] to-[#10142f] border border-[rgba(139,146,176,0.25)] shadow-[0_12px_40px_rgba(0,0,0,0.6)] overflow-hidden group">
      <div className="absolute inset-[-60%] bg-gradient-to-br from-transparent via-[rgba(0,212,255,0.24)] via-[rgba(139,92,246,0)] to-[rgba(0,212,255,0.32)] opacity-0 group-hover:opacity-70 transition-opacity duration-250 pointer-events-none" />
      <div className="flex items-center justify-between gap-2 mb-2.5 relative z-10">
        <span className="text-xs uppercase tracking-[0.14em] text-[#8b92b0]">
          {data.label}
        </span>
        <span className="text-[11px] px-2.5 py-1 rounded-full border border-[rgba(139,146,176,0.7)] text-[#8b92b0]">
          {data.tag}
        </span>
      </div>
      <div className="font-jetbrains-mono text-2xl font-semibold bg-gradient-to-r from-white to-cyber-blue bg-clip-text text-transparent mb-1.5 relative z-10">
        {data.value}
      </div>
      <div className="flex items-center justify-between text-[11px] text-[#8b92b0] relative z-10">
        <span>{data.subtitle}</span>
        <span
          className={`inline-flex items-center gap-1.25 px-2 py-0.5 rounded-full text-[11px] ${
            data.change.type === "positive"
              ? "bg-[rgba(0,255,136,0.12)] text-neon-green"
              : "bg-[rgba(255,51,102,0.12)] text-error-red"
          }`}
        >
          ▲ {data.change.value}
        </span>
      </div>
      <div className="absolute inset-x-2.5 bottom-2 h-10 opacity-55">
        <svg
          viewBox="0 0 100 30"
          preserveAspectRatio="none"
          className="w-full h-full"
        >
          <polyline
            fill="none"
            stroke={data.sparkline.stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            points={data.sparkline.points}
          />
        </svg>
      </div>
    </article>
  );
};
